module.exports = __webpack_public_path__ + "img/bg-unactive.5333014b.png";